export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8627.c12b7b69.jpg";